export const DEFAULT_LABEL_BACKGROUND_COLOR = 'var(--color-bg-second)'
